import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { axiosInstance, RELAY } from "api";
import { getSelectedPowerPlant, useAppSelector } from "store";

export type RelayChannelResponse = {
  channelNumber: number;
  name: string;
  isOn: boolean;
  hasPendingCommand: boolean;
};

export const useGetRelayChannels = () => {
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const meterId = selectedPowerPlant?.meterId;

  return useQuery<RelayChannelResponse[]>({
    queryKey: [RELAY.RELAY(meterId!)],
    queryFn: async () => {
      const { data } = await axiosInstance.get<RelayChannelResponse[]>(
        RELAY.RELAY(meterId!),
      );
      return data;
    },
    enabled: !!meterId && !!selectedPowerPlant?.relayChannelCount,
    refetchInterval: 5000,
  });
};

export const useSetRelayCommand = () => {
  const queryClient = useQueryClient();
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const meterId = selectedPowerPlant?.meterId;

  return useMutation({
    mutationFn: ({
      channelNumber,
      desiredState,
      name,
    }: {
      channelNumber: number;
      desiredState?: boolean;
      name?: string;
    }) =>
      axiosInstance.put(RELAY.RELAY_CHANNEL(meterId!, channelNumber), {
        desiredState,
        name,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RELAY.RELAY(meterId!)] });
    },
  });
};
